import fetcher from '@/services/fetcher'
import { buildQuery } from '@/utils/helpers'

export const GET_PRODUCT_DAILY_SALES = `
  query DailySales(
    $filter: DailySaleFilterInput
    $pageSize: Int
    $currentPage: Int
  ) {
    DailySales(
      filter: $filter
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      items {
        color_code
        end_date
        entity_id
        identifier
        meta_description
        meta_image
        meta_image_banner
        meta_image_mobile
        meta_keywords
        meta_title
        priority
        show_in_home
        start_date
        status
        title
        title_en
        items {
          show_percent
          rating_summary_daily_sale
          price_original
          entity_id
          product {
            ...ProductInterfaceField
          }
          product_id
          sale_price
          sale_qty
          saleable_qty
          sold_qty
          start_date
          sku_parent
          configurable_options {
            attribute_code
            attribute_uid
            label
            position
            uid
            values {
              default_label
              label
              uid
              swatch_data {
                value
              }
            }
          }
        }
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      total_count
    }
  }

  fragment ProductInterfaceField on ProductInterface {
    __typename
    sku
    uid
    name
    url_key
    url_suffix
    canonical_url
    categories {
      __typename
      name
      url_key
      url_path
      level
      uid
      icon_image
      image
      path
    }
    meta_description
    meta_keyword
    meta_title
    new_from_date
    new_to_date
    description {
      ...ComplexTextValueFields
    }
    rating_summary
    review_count
    short_description {
      ...ComplexTextValueFields
    }
    thumbnail {
      position
      ...ProductImageFields
    }
    image {
      ...ProductImageFields
    }
    media_gallery {
      __typename
      disabled
      label
      url
      position
    }
    price_range {
      ...PriceRangeField
    }
  }

  fragment PriceRangeField on PriceRange {
    __typename
    maximum_price {
      ...ProductPriceField
    }
    minimum_price {
      ...ProductPriceField
    }
  }

  fragment ProductPriceField on ProductPrice {
    discount {
      amount_off
      percent_off
    }
    final_price {
      ...MoneyFields
    }
    regular_price {
      ...MoneyFields
    }
  }

  fragment ComplexTextValueFields on ComplexTextValue {
    html
  }

  fragment ProductImageFields on ProductImage {
    url
  }

  fragment MoneyFields on Money {
    currency
    value
  }
`
export const fetchDailySales = async (params?: IFetchDailySalesParams): Promise<IDailySalesResponse> => {
  const { filter = { status: { eq: 1 } }, pageSize = 10, currentPage = 1 } = params || {}

  try {
    const response = await fetcher.get(
      buildQuery(GET_PRODUCT_DAILY_SALES, {
        filter,
        pageSize,
        currentPage,
      }),
      {
        next: { revalidate: 60, tags: ['daily-sales'] },
        cache: 'force-cache',
      }
    )

    const data = response?.payload?.data?.DailySales

    if (!data) {
      return { items: [], total_count: 0, page_info: null }
    }

    return data
  } catch (err) {
    console.error('Error fetching daily sales:', err)
    return { items: [], total_count: 0, page_info: null }
  }
}
